<div class="sf-send-when">
  <label class="sf-send-when__opt" [class.is-disabled]="!nowInWindow">
    <input
      type="radio"
      [name]="radioName"
      [checked]="sendNow"
      [disabled]="!nowInWindow"
      (change)="select(true)"
      [attr.title]="!nowInWindow ? 'Fora do horário de envio' : null"
      [attr.data-testid]="testId ? testId + '-now' : null"
    />
    <span>Enviar agora</span>
  </label>
  <label class="sf-send-when__opt">
    <input
      type="radio"
      [name]="radioName"
      [checked]="!sendNow"
      (change)="select(false)"
      [attr.data-testid]="testId ? testId + '-scheduled' : null"
    />
    <span>Agendar para data e hora</span>
  </label>

  <div class="notice notice--success notice--sm" *ngIf="sendNow && nowInWindow">
    <i class="fa fa-info-circle"></i>
    <div class="notice__body">O envio começa assim que você confirmar.</div>
  </div>
  <div class="notice notice--warning notice--sm" *ngIf="!nowInWindow">
    <i class="fa fa-exclamation-triangle"></i>
    <div class="notice__body">
      Agora está fora do horário de envio ({{ window.start }}–{{ window.stop }}, horário de Brasília). Agende para dentro da janela.
    </div>
  </div>

  <div class="sf-send-when__picker" *ngIf="!sendNow">
    <ng-content></ng-content>
  </div>
</div>
